export default "__VITE_ASSET__D8X2Tzl7__"